import memoize from 'lodash/memoize';
import { DisplayUnitsContextType } from './displayUnits/types';
import { customEventBindingsSelector } from './widget/selectors';
import { WidgetState } from './widget/types';

export const displayUnitsCustomEventsBindingSelector = memoize(
  (widgetState: WidgetState, displayUnitsState: DisplayUnitsContextType) => {
    const customEventBindings = customEventBindingsSelector(widgetState);
    const displayUnitIds = displayUnitsState.displayUnits;

    if (!customEventBindings) {
      return undefined;
    }

    return Object.keys(customEventBindings).reduce(
      (filteredBindingsMap, bindingKey) => {
        const key = bindingKey as keyof typeof customEventBindings;
        const bindings = customEventBindings[key];
        const filteredBindings = bindings.filter(
          (e) => e.unitId !== undefined && displayUnitIds.includes(e.unitId),
        );
        filteredBindingsMap[key] = filteredBindings;
        return filteredBindingsMap;
      },
      {} as typeof customEventBindings,
    );
  },
);
